import type { LineHeight } from '../../types'
import * as tokens from './generated-tokens/ts/line-height'

// @TODO: Decide on object key naming for these
export const lineHeight: LineHeight = {
  [15]: tokens.SbLineHeight15,
  [20]: tokens.SbLineHeight20,
  [25]: tokens.SbLineHeight25,
  [28]: tokens.SbLineHeight28,
  [30]: tokens.SbLineHeight30,
  [35]: tokens.SbLineHeight35,
  [40]: tokens.SbLineHeight40,
  [45]: tokens.SbLineHeight45,
  [48]: tokens.SbLineHeight48,
  [50]: tokens.SbLineHeight50,
  [60]: tokens.SbLineHeight60,
}
